module.exports = __webpack_public_path__ + "static/media/24_A.47f2125a.png";